import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'
import { View } from 'react-native'
import { getChartDateRange } from 'services/redux/management/reducers'
import { GraphDateRangeStyles } from 'styles/components/atoms/GraphDateRange'
import { setChartDateRange } from 'services/redux/management/actions'
import ThemedRangeDatepicker from 'components/atoms/ThemedRangeDatepicker'
import isEqual from 'react-fast-compare'
import HelperDate, { dateFormat } from 'utils/helper-date'

export const formatDateRange = ( range ) => {

	return _.map( range, date => {
		return HelperDate.date(date, undefined, true).format(dateFormat.DATE);
	})
}

const GraphDateRange = ({ containerStyle = {} }) => {
	
	const dispatch = useDispatch()
	const _graphDateRange = useSelector( state => {
		return getChartDateRange(state);
	} )
	
	const [ selectedDateRange, setSelectedDateRange ] = useState( _graphDateRange );
	
	const viewStyle = [
		GraphDateRangeStyles.container,
		containerStyle
	]
	
	const onRangePickerSelect = ( range ) => {
		setSelectedDateRange( range )
		
		let isValid = true;
		_.forEach( range, date => {
			if( date === null ) {
				isValid = false;
				return true;
			}
		})
		
		if( isValid ) {
			dispatch( setChartDateRange( range ) )
		}
	}

	return (
		<View
			style={ viewStyle }>
			
			<ThemedRangeDatepicker
				range={ selectedDateRange }
				onSelect={ onRangePickerSelect }
				style={ GraphDateRangeStyles.picker }
			/>
		</View>
	)
}

export default React.memo( GraphDateRange, isEqual );
